import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/appointments.js'), 'appointments.js')
  resolveStoreModules(require('../store/asthmaReportView.js'), 'asthmaReportView.js')
  resolveStoreModules(require('../store/communicationLogs.js'), 'communicationLogs.js')
  resolveStoreModules(require('../store/communicationPreferences.js'), 'communicationPreferences.js')
  resolveStoreModules(require('../store/devices.js'), 'devices.js')
  resolveStoreModules(require('../store/filters.js'), 'filters.js')
  resolveStoreModules(require('../store/layout.js'), 'layout.js')
  resolveStoreModules(require('../store/messaging.js'), 'messaging.js')
  resolveStoreModules(require('../store/overreading.js'), 'overreading.js')
  resolveStoreModules(require('../store/overwriting.js'), 'overwriting.js')
  resolveStoreModules(require('../store/portal.js'), 'portal.js')
  resolveStoreModules(require('../store/profile.js'), 'profile.js')
  resolveStoreModules(require('../store/profileActivity.js'), 'profileActivity.js')
  resolveStoreModules(require('../store/profileCarePlan.js'), 'profileCarePlan.js')
  resolveStoreModules(require('../store/profileCareTeam.js'), 'profileCareTeam.js')
  resolveStoreModules(require('../store/profiles.js'), 'profiles.js')
  resolveStoreModules(require('../store/questionnaires.js'), 'questionnaires.js')
  resolveStoreModules(require('../store/rewards.js'), 'rewards.js')
  resolveStoreModules(require('../store/sidebar.js'), 'sidebar.js')
  resolveStoreModules(require('../store/snackbar.js'), 'snackbar.js')
  resolveStoreModules(require('../store/sso.js'), 'sso.js')
  resolveStoreModules(require('../store/timeline.js'), 'timeline.js')
  resolveStoreModules(require('../store/timeTracker.js'), 'timeTracker.js')
  resolveStoreModules(require('../store/today.js'), 'today.js')
  resolveStoreModules(require('../store/todos.js'), 'todos.js')
  resolveStoreModules(require('../store/unitsAndFormats.js'), 'unitsAndFormats.js')
  resolveStoreModules(require('../store/video.js'), 'video.js')
  resolveStoreModules(require('../store/zoom.js'), 'zoom.js')
  resolveStoreModules(require('../store/asthmaReport/actions.js'), 'asthmaReport/actions.js')
  resolveStoreModules(require('../store/asthmaReport/getters.js'), 'asthmaReport/getters.js')
  resolveStoreModules(require('../store/asthmaReport/mutations.js'), 'asthmaReport/mutations.js')
  resolveStoreModules(require('../store/asthmaReport/state.js'), 'asthmaReport/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
